module.exports = __webpack_public_path__ + "img/ourplacepeel.d5cabbcc.jpg";